import React from 'react';

import { SvgIcon, useTheme } from '@mui/material';

interface FilterIconProps {
  isActive: boolean;
}

/**
 * Компонент для отображения иконки фильтра, которая изменяет свой цвет в зависимости от активного состояния.
 *
 * @param {Object} props - Свойства, которые можно передать компоненту FilterIcon.
 * @param {boolean} [props.isActive=false] - Определяет, является ли иконка фильтра активной.
 * @returns {JSX.Element} JSX-элемент, представляющий иконку фильтра.
 */

export const FilterIcon = ({ isActive = false }: FilterIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon
      htmlColor={isActive ? 'primary' : theme.tokens.colors.bg.light.primary}
      viewBox="0 0 25 24"
    >
      <path
        stroke={isActive ? 'primary' : theme.tokens.colors.stroke.secondary}
        d="M20.8418 5H4.8418L11.2418 12.3578V17.4444L14.4418 19V12.3578L20.8418 5Z"
      />
    </SvgIcon>
  );
};
